import axios from 'axios';
import { Plant } from 'views/feed-management/features/plants/types/plant.type';

// GET
// Returns plant.
// /ewosapi/v1/bestmix/plant/{code}
export const getFeedManagementPlant = async (code: string): Promise<Plant> => {
  const res = await axios.get<Plant>(`/ewosapi/v1/bestmix/plant/${code}`);
  return res.data;
};

// GET
// /ewosapi/v1/bestmix/plant/user
// Returns plants for user markets.
export const getFeedManagementUserPlants = async (): Promise<Plant[]> => {
  const res = await axios.get<Plant[]>(`/ewosapi/v1/bestmix/plant/user`);
  return res.data;
};

// GET
// /ewosapi/v1/bestmix/plant
// Returns list of plants.
export const getFeedManagementPlants = async (): Promise<Plant[]> => {
  const res = await axios.get<Plant[]>(`/ewosapi/v1/bestmix/plant`);
  return res.data;
};
